import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index';
import { createPinia } from 'pinia';
import i18n from './i18n';
import BlackDashboard from './plugins/blackDashboard';
import './registerServiceWorker';
import { plugin as vueTransitionsPlugin } from '@morev/vue-transitions';
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import Tooltip from 'primevue/tooltip';



// Создание приложения
const app = createApp(App);

const pinia = createPinia();

// Использование плагинов
app.use(pinia);
app.use(router);
app.use(i18n);
app.use(BlackDashboard);
app.use(vueTransitionsPlugin({}));
app.directive('tooltip', Tooltip);
app.use(PrimeVue, {
    theme: {
        preset: Aura,
    },
    zIndex: {
        overlay: 10000,
    },
    locale: {
        dayNames: [
            'Воскресенье',
            'Понедельник',
            'Вторник',
            'Среда',
            'Четверг',
            'Пятница',
            'Суббота',
        ],
        dayNamesShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        monthNames: [
            'Январь',
            'Февраль',
            'Март',
            'Апрель',
            'Май',
            'Июнь',
            'Июль',
            'Август',
            'Сентябрь',
            'Октябрь',
            'Ноябрь',
            'Декабрь',
        ],
        monthNamesShort: [
            'Янв',
            'Фев',
            'Мар',
            'Апр',
            'Май',
            'Июн',
            'Июл',
            'Авг',
            'Сен',
            'Окт',
            'Ноя',
            'Дек',
        ],
        firstDayOfWeek: 1,
    },
});

// Монтирование приложения
app.mount('#app');
